import { selectCategory } from "@/store/slices/category";
import React from "react";
import { useSelector } from "react-redux";

const PaginationCounterUnbxd = () => {
  const categoryState = useSelector(selectCategory);
  if (categoryState.products?.response?.products?.length) {
    return (
      <>
        Showing 1 - {categoryState.products?.response?.products?.length} of{" "}
        {categoryState.products?.response?.numberOfProducts}
      </>
    );
  }
  return <></>;
};

export default PaginationCounterUnbxd;
